// packages/ag-charts-locale/src/he-IL.ts
var AG_CHARTS_LOCALE_HE_IL = {
  ariaAnnounceChart: "\u05EA\u05E8\u05E9\u05D9\u05DD, ${seriesCount}[number] \u05E1\u05D3\u05E8\u05D5\u05EA",
  ariaAnnounceFlowProportionLink: "\u05E7\u05D9\u05E9\u05D5\u05E8 ${index} \u05DE\u05EA\u05D5\u05DA ${count}, \u05DE-${from} \u05DC-${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u05E6\u05D5\u05DE\u05EA ${index} \u05DE\u05EA\u05D5\u05DA ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u05EA\u05E8\u05E9\u05D9\u05DD \u05DE\u05D3, ${caption}",
  ariaAnnounceHierarchyChart: "\u05EA\u05E8\u05E9\u05D9\u05DD \u05D4\u05D9\u05E8\u05E8\u05DB\u05D9, ${caption}",
  ariaAnnounceHierarchyDatum: "\u05E8\u05DE\u05D4 ${level}[number], ${count}[number] \u05D9\u05DC\u05D3\u05D9\u05DD, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u05DC\u05D7\u05E5 \u05E2\u05DC \u05DE\u05E7\u05E9 \u05D4\u05E8\u05D5\u05D5\u05D7 \u05D0\u05D5 \u05D0\u05E0\u05D8\u05E8 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05D7\u05DC\u05D9\u05E3 \u05D0\u05EA \u05D4\u05E0\u05E8\u05D0\u05D5\u05EA",
  ariaLabelAddHorizontalLine: "\u05D4\u05D5\u05E1\u05E3 \u05E7\u05D5 \u05D0\u05D5\u05E4\u05E7\u05D9",
  ariaLabelAnnotationOptionsToolbar: "\u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA \u05D4\u05E2\u05E8\u05D5\u05EA",
  ariaLabelAnnotationSettingsDialog: '"\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA \u05D4\u05E2\u05E8\u05D5\u05EA"',
  ariaLabelColorPicker: "\u05D1\u05D5\u05D7\u05E8 \u05E6\u05D1\u05E2\u05D9\u05DD",
  ariaLabelFinancialCharts: "\u05EA\u05E8\u05E9\u05D9\u05DE\u05D9\u05DD \u05E4\u05D9\u05E0\u05E0\u05E1\u05D9\u05D9\u05DD",
  ariaLabelLegend: "\u05DE\u05E7\u05E8\u05D0",
  ariaLabelLegendItem: "${label}, \u05E4\u05E8\u05D9\u05D8 \u05D1\u05D0\u05D2\u05D3\u05D4 ${index}[number] \u05DE\u05EA\u05D5\u05DA ${count}[number]",
  ariaLabelLegendItemUnknown: "\u05E4\u05E8\u05D9\u05D8 \u05DE\u05E7\u05E8\u05D0 \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2",
  ariaLabelLegendPageNext: "\u05E2\u05DE\u05D5\u05D3 \u05D4\u05DE\u05E7\u05E8\u05D0 \u05D4\u05D1\u05D0",
  ariaLabelLegendPagePrevious: "\u05E2\u05DE\u05D5\u05D3 \u05D4\u05DE\u05E7\u05E8\u05D0 \u05D4\u05E7\u05D5\u05D3\u05DD",
  ariaLabelLegendPagination: "\u05E0\u05D5\u05D5\u05D8 \u05D1\u05D3\u05E4\u05D9 \u05D4\u05DE\u05E7\u05E8\u05D0",
  ariaLabelNavigator: "\u05E0\u05D5\u05D5\u05D8",
  ariaLabelNavigatorMaximum: "\u05DE\u05E7\u05E1\u05D9\u05DE\u05D5\u05DD",
  ariaLabelNavigatorMinimum: "\u05DE\u05D9\u05E0\u05D9\u05DE\u05D5\u05DD",
  ariaLabelNavigatorRange: "\u05D8\u05D5\u05D5\u05D7",
  ariaLabelRangesToolbar: "\u05D8\u05D5\u05D5\u05D7\u05D9\u05DD",
  ariaLabelSettingsTabBar: "\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA",
  ariaLabelZoomToolbar: "\u05D6\u05D5\u05DD",
  ariaValuePanRange: "${min}[percent0to2dp] \u05E2\u05D3 ${max}[percent0to2dp]",
  contextMenuDownload: "\u05D4\u05D5\u05E8\u05D3\u05D4",
  contextMenuPanToCursor: "\u05D2\u05DC\u05D5\u05DC \u05DC\u05E4\u05D4",
  contextMenuToggleOtherSeries: "\u05D4\u05D7\u05DC\u05E3 \u05E0\u05E8\u05D0\u05D5\u05EA \u05E9\u05DC \u05E1\u05D3\u05E8\u05D5\u05EA \u05D0\u05D7\u05E8\u05D5\u05EA",
  contextMenuToggleSeriesVisibility: "\u05D4\u05D7\u05DC\u05E3 \u05E0\u05E8\u05D0\u05D5\u05EA",
  contextMenuZoomToCursor: "\u05D4\u05EA\u05E7\u05E8\u05D1 \u05DC\u05DB\u05D0\u05DF",
  dialogHeaderChannel: "\u05E2\u05E8\u05D5\u05E5",
  dialogHeaderDatePriceRange: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D5\u05DE\u05D7\u05D9\u05E8",
  dialogHeaderDateRange: " '\u05D8\u05D5\u05D5\u05D7 \u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD'",
  dialogHeaderFibonacciRange: "\u05EA\u05D9\u05E7\u05D5\u05DF \u05E4\u05D9\u05D1",
  dialogHeaderLine: "\u05E7\u05D5",
  dialogHeaderPriceRange: "\u05D8\u05D5\u05D5\u05D7 \u05DE\u05D7\u05D9\u05E8\u05D9\u05DD",
  dialogHeaderText: "\u05D8\u05E7\u05E1\u05D8",
  dialogInputAlign: "\u05D9\u05E9\u05D5\u05E8",
  dialogInputColorPicker: "\u05E6\u05D1\u05E2",
  dialogInputColorPickerAltText: "\u05E6\u05D1\u05E2 \u05D8\u05E7\u05E1\u05D8",
  dialogInputExtendAbove: "\u05DC\u05D4\u05E8\u05D7\u05D9\u05D1 \u05DC\u05DE\u05E2\u05DC\u05D4",
  dialogInputExtendBelow: "\u05D4\u05E8\u05D7\u05D1 \u05DE\u05D8\u05D4",
  dialogInputExtendChannelEnd: "\u05D4\u05D0\u05E8\u05DA \u05E1\u05D5\u05E3 \u05E2\u05E8\u05D5\u05E5",
  dialogInputExtendChannelStart: "\u05D4\u05E8\u05D7\u05D1 \u05EA\u05D7\u05D9\u05DC\u05EA \u05E2\u05E8\u05D5\u05E5",
  dialogInputExtendLeft: "\u05D4\u05E8\u05D7\u05D1 \u05E9\u05DE\u05D0\u05DC\u05D4",
  dialogInputExtendLineEnd: "\u05D4\u05E8\u05D7\u05D1 \u05E7\u05E6\u05D4 \u05E7\u05D5",
  dialogInputExtendLineStart: "\u05D4\u05E8\u05D7\u05D1 \u05D4\u05EA\u05D7\u05DC\u05EA \u05D4\u05E7\u05D5",
  dialogInputExtendRight: "\u05E9\u05DC\u05D7 \u05DC\u05D9\u05DE\u05D9\u05DF",
  dialogInputFibonacciBands: "\u05E8\u05E6\u05D5\u05E2\u05D5\u05EA",
  dialogInputFibonacciBandsAltText: "\u05E8\u05E6\u05D5\u05E2\u05D5\u05EA \u05E4\u05D9\u05D1\u05D5\u05E0\u05D0\u05E6'\u05D9",
  dialogInputFillColorPicker: "\u05DE\u05D9\u05DC\u05D5\u05D9",
  dialogInputFillColorPickerAltText: "\u05E6\u05D1\u05E2 \u05DE\u05D9\u05DC\u05D5\u05D9",
  dialogInputFontSize: "\u05D2\u05D5\u05D3\u05DC",
  dialogInputFontSizeAltText: "\u05D2\u05D5\u05D3\u05DC \u05D2\u05D5\u05E4\u05DF",
  dialogInputLineStyle: "\u05E7\u05D5 \u05DE\u05E7\u05D5\u05D5\u05E7\u05D5",
  dialogInputPosition: "\u05DE\u05D9\u05E7\u05D5\u05DD",
  dialogInputReverse: "\u05D4\u05E4\u05D5\u05DA",
  dialogInputShowFill: "\u05D4\u05E6\u05D2 \u05DE\u05D9\u05DC\u05D5\u05D9",
  dialogInputStrokeWidth: "\u05DE\u05E9\u05E7\u05DC",
  dialogInputStrokeWidthAltText: "\u05DE\u05E9\u05E7\u05DC \u05D4\u05E7\u05D5",
  iconAltTextAlignCenter: "\u05DE\u05E8\u05DB\u05D6",
  iconAltTextAlignLeft: "\u05E9\u05DE\u05D0\u05DC",
  iconAltTextAlignRight: "\u05DE\u05D9\u05D5\u05E9\u05E8 \u05D9\u05DE\u05D9\u05E0\u05D4",
  iconAltTextClose: "\u05E1\u05D2\u05D5\u05E8",
  iconAltTextLineStyleDashed: "\u05D0\u05E8\u05D5\u05DA \u05DE\u05E7\u05D5\u05D5\u05E7\u05D5",
  iconAltTextLineStyleDotted: "\u05DE\u05B0\u05E7\u05D5\u05BC\u05D5\u05B8\u05D5 \u05E7\u05B8\u05E6\u05B8\u05E8",
  iconAltTextLineStyleSolid: "\u05DE\u05D5\u05E6\u05E7",
  iconAltTextPositionBottom: "\u05EA\u05D7\u05EA\u05D5\u05DF",
  iconAltTextPositionCenter: "\u05DE\u05E8\u05DB\u05D6",
  iconAltTextPositionTop: "\u05DC\u05DE\u05E2\u05DC\u05D4",
  inputTextareaPlaceholder: "\u05D4\u05D5\u05E1\u05E3 \u05D8\u05E7\u05E1\u05D8",
  measurerDateRangeBars: "${value}[number] \u05E7\u05D5\u05D5\u05D9\u05DD",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u05E0\u05E4\u05D7 ${value}",
  overlayLoadingData: "\u05D8\u05D5\u05E2\u05DF \u05E0\u05EA\u05D5\u05E0\u05D9\u05DD...",
  overlayNoData: "\u05D0\u05D9\u05DF \u05E0\u05EA\u05D5\u05E0\u05D9\u05DD \u05DC\u05D4\u05E6\u05D2\u05D4",
  overlayNoVisibleSeries: "\u05D0\u05D9\u05DF \u05E1\u05D3\u05E8\u05D5\u05EA \u05DC\u05D4\u05E6\u05D9\u05D2",
  overlayUnsupportedBrowser: "\u05D2\u05E8\u05E1\u05EA \u05D3\u05E4\u05D3\u05E4\u05DF \u05DC\u05D0 \u05EA\u05D5\u05D0\u05DE\u05EA. \u05E0\u05D0 \u05DC\u05E9\u05D3\u05E8\u05D2 \u05D0\u05EA \u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA.",
  seriesHistogramTooltipCount: "${yName} (\u05DB\u05DE\u05D5\u05EA)",
  seriesHistogramTooltipFrequency: "\u05EA\u05D3\u05D9\u05E8\u05D5\u05EA",
  seriesHistogramTooltipMean: "${yName} (\u05DE\u05DE\u05D5\u05E6\u05E2)",
  seriesHistogramTooltipSum: "${yName} (\u05E1\u05DB\u05D5\u05DD)",
  toolbarAnnotationsArrow: "\u05D7\u05E5",
  toolbarAnnotationsArrowDown: "\u05D7\u05E5 \u05DC\u05DE\u05D8\u05D4",
  toolbarAnnotationsArrowUp: "\u05D7\u05E5 \u05DC\u05DE\u05E2\u05DC\u05D4",
  toolbarAnnotationsCallout: "\u05D4\u05E2\u05E8\u05D4",
  toolbarAnnotationsClearAll: "\u05E0\u05E7\u05D4 \u05D4\u05DB\u05DC",
  toolbarAnnotationsComment: "\u05EA\u05D2\u05D5\u05D1\u05D4",
  toolbarAnnotationsDatePriceRange: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D5\u05DE\u05D7\u05D9\u05E8",
  toolbarAnnotationsDateRange: "\u05D8\u05D5\u05D5\u05D7 \u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD",
  toolbarAnnotationsDelete: "\u05DE\u05D7\u05E7",
  toolbarAnnotationsDisjointChannel: "\u05E2\u05E8\u05D5\u05E5 \u05DE\u05E0\u05D5\u05EA\u05E7",
  toolbarAnnotationsDragHandle: "\u05D2\u05E8\u05D5\u05E8 \u05E1\u05E8\u05D2\u05DC \u05DB\u05DC\u05D9\u05DD",
  toolbarAnnotationsFibonacciAnnotations: "\u05E4\u05D9\u05D1\u05D5\u05E0\u05D0\u05E6'\u05D9",
  toolbarAnnotationsFibonacciRetracement: "\u05EA\u05D9\u05E7\u05D5\u05DF \u05E4\u05D9\u05D1\u05D5\u05E0\u05D0\u05E6'\u05D9",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u05E4\u05D9\u05D1 \u05D8\u05E8\u05E0\u05D3 \u05DE\u05D1\u05D5\u05E1\u05E1",
  toolbarAnnotationsFillColor: "\u05E6\u05D1\u05E2 \u05DE\u05D9\u05DC\u05D5\u05D9",
  toolbarAnnotationsHorizontalLine: "\u05E7\u05D5 \u05D0\u05D5\u05E4\u05E7\u05D9",
  toolbarAnnotationsLineAnnotations: "\u05E7\u05D5\u05D5\u05D9 \u05DE\u05D2\u05DE\u05D4",
  toolbarAnnotationsLineColor: "\u05E6\u05D1\u05E2 \u05D4\u05E7\u05D5",
  toolbarAnnotationsLineStrokeWidth: "\u05E2\u05D5\u05D1\u05D9 \u05E7\u05D5",
  toolbarAnnotationsLineStyle: "\u05E1\u05D2\u05E0\u05D5\u05DF \u05E7\u05D5",
  toolbarAnnotationsLock: "\u05E0\u05E2\u05DC",
  toolbarAnnotationsMeasurerAnnotations: "\u05DE\u05D5\u05D3\u05D3",
  toolbarAnnotationsNote: "\u05D4\u05E2\u05E8\u05D4",
  toolbarAnnotationsParallelChannel: "\u05E2\u05E8\u05D5\u05E5 \u05DE\u05E7\u05D1\u05D9\u05DC\u05D9",
  toolbarAnnotationsPriceRange: "\u05D8\u05D5\u05D5\u05D7 \u05DE\u05D7\u05D9\u05E8\u05D9\u05DD",
  toolbarAnnotationsQuickDatePriceRange: "\u05D4\u05E2\u05E8\u05DB\u05D4",
  toolbarAnnotationsSettings: "\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA",
  toolbarAnnotationsShapeAnnotations: "\u05D7\u05D9\u05E6\u05D9\u05DD",
  toolbarAnnotationsText: "\u05D8\u05E7\u05E1\u05D8",
  toolbarAnnotationsTextAnnotations: "\u05D4\u05E2\u05E8\u05D5\u05EA \u05D8\u05E7\u05E1\u05D8",
  toolbarAnnotationsTextColor: "\u05E6\u05D1\u05E2 \u05D8\u05E7\u05E1\u05D8",
  toolbarAnnotationsTextSize: "\u05D2\u05D5\u05D3\u05DC \u05D8\u05E7\u05E1\u05D8",
  toolbarAnnotationsTrendLine: "\u05E7\u05D5 \u05DE\u05D2\u05DE\u05D4",
  toolbarAnnotationsUnlock: "\u05E9\u05D7\u05E8\u05E8",
  toolbarAnnotationsVerticalLine: "\u05E7\u05D5 \u05D0\u05E0\u05DB\u05D9",
  toolbarRange1Month: "1 \u05D7\u05D5\u05D3\u05E9",
  toolbarRange1MonthAria: "\u05D7\u05D5\u05D3\u05E9 \u05D0\u05D7\u05D3",
  toolbarRange1Year: "\u05E9\u05E0\u05D4 1",
  toolbarRange1YearAria: "\u05E9\u05E0\u05D4 \u05D0\u05D7\u05EA",
  toolbarRange3Months: "3 \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD",
  toolbarRange3MonthsAria: "3 \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD",
  toolbarRange6Months: "6\u05D7",
  toolbarRange6MonthsAria: "6 \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD",
  toolbarRangeAll: "\u05D4\u05DB\u05DC",
  toolbarRangeAllAria: "\u05D4\u05DB\u05DC",
  toolbarRangeYearToDate: "\u05D4\u05E9\u05E0\u05D4",
  toolbarRangeYearToDateAria: "\u05D4\u05E9\u05E0\u05D4",
  toolbarSeriesTypeCandles: "\u05E0\u05E8\u05D5\u05EA",
  toolbarSeriesTypeDropdown: "\u05E1\u05D5\u05D2 \u05EA\u05E8\u05E9\u05D9\u05DD",
  toolbarSeriesTypeHighLow: "\u05D2\u05D1\u05D5\u05D4 \u05E0\u05DE\u05D5\u05DA",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u05E0\u05E8\u05D5\u05EA \u05D7\u05DC\u05D5\u05DC\u05D9\u05DD",
  toolbarSeriesTypeLine: "\u05E7\u05D5",
  toolbarSeriesTypeLineWithMarkers: "\u05E7\u05D5 \u05E2\u05DD \u05E1\u05D9\u05DE\u05D5\u05E0\u05D9\u05DD",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u05E7\u05D5 \u05DE\u05D3\u05E8\u05D2\u05D5\u05EA",
  toolbarZoomPanEnd: "\u05D2\u05DC\u05D5\u05DC \u05DC\u05E1\u05D5\u05E3",
  toolbarZoomPanLeft: "\u05D2\u05DC\u05D5\u05DC \u05E9\u05DE\u05D0\u05DC\u05D4",
  toolbarZoomPanRight: "\u05D2\u05DC\u05D5\u05DC \u05D9\u05DE\u05D9\u05E0\u05D4",
  toolbarZoomPanStart: "\u05D2\u05DC\u05D5\u05DC \u05DC\u05D4\u05EA\u05D7\u05DC\u05D4",
  toolbarZoomReset: "\u05D0\u05E4\u05E1 \u05D6\u05D5\u05DD",
  toolbarZoomZoomIn: "\u05D4\u05EA\u05E7\u05E8\u05D1",
  toolbarZoomZoomOut: "\u05D4\u05EA\u05E8\u05D7\u05E7",
  tooltipPaginationStatus: "${index}[number] \u05DE\u05EA\u05D5\u05DA ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_HE_IL
};
//# sourceMappingURL=he-IL.esm.mjs.map
